import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { sendFundTransferDd } from "../../redux/InwardIteraction/actions";
import InwardXml from "../Nip/InwardInteraction";

const FundTransferDirectDebit = (props) => {
  const {
    goToFundTransferAdviceDirectDebit,
    goToFundTransferAdviceDirectCredit,
    sendType,
    fundTransferDd,
    isLoading,
  } = props;

  const handleFundTransferDd1 = () => {
    const payload = {
      type: "valid_ref",
    };
    sendType(payload);
  };

  const handleFundTransferDd2 = () => {
    const payload = {
      type: "invalid_ref",
    };
    sendType(payload);
  };

  const request = fundTransferDd && fundTransferDd.request;
  const response = fundTransferDd && fundTransferDd.response;

  return (
    <InwardXml
      prev={goToFundTransferAdviceDirectCredit}
      next={goToFundTransferAdviceDirectDebit}
      title={"Fund Transfer Direct Debit"}
      request={request}
      response={response}
      optiontitle1={"Valid Ref"}
      optiontitle2={"Invalid Ref"}
      handleCase1={handleFundTransferDd1}
      handleCase2={handleFundTransferDd2}
      isLoading={isLoading}
    />
  );
};

FundTransferDirectDebit.propTypes = {
  fundTransferDd: PropTypes.shape({
    request: PropTypes.string,
    response: PropTypes.string,
  }),
  goToFundTransferAdviceDirectCredit: PropTypes.func,
  goToFundTransferAdviceDirectDebit: PropTypes.func,
  isLoading: PropTypes.bool,
  sendType: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.inwardInteraction.isLoading,
    sendFundTransferDdSuccess:
      state.inwardInteraction.sendFundTransferDdSuccess,
    fundTransferDd: state.inwardInteraction.sendFundTransferDd,
  };
};

const mapDispatchToProps = (dispatch) => ({
  sendType: (payload) => dispatch(sendFundTransferDd(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FundTransferDirectDebit);
